module.exports = __webpack_public_path__ + "static/media/17.9776738a.webp";